import type { ToastDetails } from 'components/Banner/BannerTypesUtils.d'
import { useEffect, useState } from 'react'
import { BANNER_TIMEOUT } from 'utils/constants'

const useToast = (scrollToBanner: boolean = false, timeout: number | undefined = BANNER_TIMEOUT) => {
  const [toastDetails, setToastDetails] = useState<ToastDetails | undefined>()

  useEffect(() => {
    if (!!toastDetails) {
      if (scrollToBanner) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }

      const timer = setTimeout(() => {
        setToastDetails(undefined)
      }, timeout)

      return () => clearTimeout(timer)
    }
  }, [toastDetails, timeout])

  return { toastDetails, setToastDetails }
}

export default useToast
